var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.hide_flag,"labels":true,"disabled":_vm.disable},on:{"change":function($event){return _vm.toggleAllCreative($event, _vm.url_token)}}})}
var staticRenderFns = []

export { render, staticRenderFns }